import store from '../store';
import { i18nInstance } from '@/plugins/i18n';
import AvatarBuilder from '../pages/AvatarBuilder';
import Questionnaire from '../pages/Questionnaire';
import InterestsSelection from '../pages/InterestsSelection';
import Login from '../pages/Login';
import NotFoundComponent from '../pages/NotFound';
import InternalError from '../pages/InternalError';
import SimulationError from '../pages/SimulationError';
import Home from '../pages/Home';
import GoalsSetting from '../pages/GoalsSetting';
import CareerClusters from '../pages/CareerClusters';
import CareerSelect from '../pages/CareerSelect';
import AdminSection from '../pages/AdminSection';
import Category from '../pages/Category';
import LoanApplication from '../pages/LoanApplication';
import Education from '../pages/Education';
import Congratulations from '../pages/Congratulations';
import Profile from '../pages/Profile';
import Calendar from '../pages/Calendar';
import SimulationSnapshotReport from '../pages/reports/SimulationSnapshotReport.vue';
import StudentSummaryReport from '../pages/reports/StudentSummaryReport';
import StudentAtGlanceReport from '../pages/reports/StudentAtGlanceReport';
import ChooseSimulation from '../pages/ChooseSimulation';
import ChooseSimReport from '../pages/ChooseSimReport';
import StudentInformationReporting from '../pages/StudentInformationReporting.vue';
import Localize from '../helpers/localizationMiddleware';

let routes = null;

const isAllowed = (to, from, next) => {
	store.dispatch('getUserData').then(response => {
		if (response) {
			const data = response.data;

			if (data.disallowedToLogIn) {
				next({
					name: 'userauthenticationerror',
					params: {
						errorMessage: data.errorMessage,
						userRoleName: data.role
					}
				});
				// stop execution of the next lines
				return;
			}

			if (data.isUserLoggedIn) {
				if (data.disAllowedUrlPaths.includes(to.name) || to.name === 'root') {
					next({ name: data.urlPathToNavigateAfterLogin });
				} else {
					next();
				}
			} else {
				redirectLogin(to, from, next);
			}
		}
	});
};

const redirectLogin = (to, from, next) => {
	if (localStorage.getItem('jaSimType') === 'AdvancedOnsite') {
		next({ name: 'login_onsite' });
	} else {
		next({ name: 'login_virtual' });
	}
};

export const getRoutes = () => {
	if (!routes) {
		routes = [
			{
				path: '/login/virtual',
				component: Login,
				name: 'login_virtual',
				props: { simulationType: 'AdvancedVirtual' },
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('loginPageEntered')
					},
					title: i18nInstance.t('generalMetaTitles.loginVirtual')
				}
			},
			{
				path: '/login/onsite',
				component: Login,
				name: 'login_onsite',
				props: { simulationType: 'AdvancedOnsite' },
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('loginPageEntered')
					},
					title: i18nInstance.t('generalMetaTitles.loginOnSite')
				}
			},
			{
				path: '/login',
				component: Login,
				name: 'login',
				beforeEnter: redirectLogin
			},
			{
				path: '/avatar',
				component: AvatarBuilder,
				name: 'avatar',
				beforeEnter: isAllowed,
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('avatarPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.avatar')
				}
			},
			{
				path: '/informationStudent',
				component: StudentInformationReporting,
				name: 'informationStudent',
				beforeEnter: isAllowed,
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('avatarPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.avatar')
				}
			},
			{
				path: '/pretest',
				component: Questionnaire,
				name: 'pretest',
				beforeEnter: isAllowed,
				props: { type: 'pretest' },
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('pretestPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.pretest')
				}
			},
			{
				path: '/clusters',
				component: CareerClusters,
				name: 'clusters',
				beforeEnter: isAllowed,
				props: true,
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('clustersPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.clusters')
				}
			},

			{
				path: '/careers',
				name: 'careers',
				component: CareerSelect,
				beforeEnter: isAllowed,
				meta: {
					announcer: {
						message: i18nInstance.tc('careerPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.careers')
				}
			},
			{
				path: '/education',
				component: Education,
				name: 'education',
				beforeEnter: isAllowed,
				meta: {
					announcer: {
						message: i18nInstance.tc('educationPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.education')
				}
			},

			{
				path: '/goals',
				component: GoalsSetting,
				name: 'goals',
				beforeEnter: isAllowed,
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('goalsPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.goals')
				}
			},
			{
				path: '/interests',
				component: InterestsSelection,
				name: 'interests',
				beforeEnter: isAllowed,
				meta: {
					announcer: {
						message: i18nInstance.tc('interestsPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.interests')
				}
			},
			{
				path: '/home',
				component: Home,
				name: 'home',
				beforeEnter: isAllowed,
				props: true,
				meta: {
					announcer: {
						message: i18nInstance.tc('homePageEntered')
					}
				}
			},
			{
				path: '/chooseSimulation',
				component: ChooseSimulation,
				name: 'chooseSimulation',
				beforeEnter: isAllowed,
				meta: {
					middleware: Localize,
					title: i18nInstance.t('gamePlayMetaTitles.chooseSim')
				}
			},
			{
				path: '/simulationsReports',
				component: ChooseSimReport,
				name: 'simReport',
				beforeEnter: isAllowed
			},
			{
				path: '/posttest',
				component: Questionnaire,
				name: 'posttest',
				beforeEnter: isAllowed,
				props: { type: 'posttest' },
				meta: {
					middleware: Localize,
					title: i18nInstance.t('gamePlayMetaTitles.posttest')
				}
			},
			{
				path: '/knowledge',
				component: Questionnaire,
				name: 'knowledge',
				beforeEnter: isAllowed,
				props: { type: 'knowledge' },
				meta: {
					middleware: Localize,
					title: i18nInstance.t('gamePlayMetaTitles.knowledge')
				}
			},
			{
				path: '/cms',
				name: 'cms',
				redirect: { name: 'cmsEvaluationQuestions' }
			},
			{
				path: 'cms/evaluationQuestion',
				redirect: 'cmsEvaluationQuestions'
			},
			{
				path: '/cms/evaluationQuestions',
				component: AdminSection,
				name: 'cmsEvaluationQuestions',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsEvaluationQuestions'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.evaluationQuestions')
				}
			},
			{
				path: '/cms/simulationTemplates',
				component: AdminSection,
				name: 'cmsSimulationTemplates',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsSimulationTemplates'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.simulationTemplates')
				}
			},
			{
				path: '/cms/careers',
				component: AdminSection,
				name: 'cmsCareers',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsCareers'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.careers')
				}
			},
			{
				path: '/cms/interest',
				component: AdminSection,
				name: 'cmsInterest',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsInterest'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.interest')
				}
			},
			{
				path: '/cms/expenseCategories',
				component: AdminSection,
				name: 'cmsExpenseCategories',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsExpenseCategories'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.expenseCategories')
				}
			},
			{
				path: '/cms/resources',
				component: AdminSection,
				name: 'cmsResources',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsResources'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.resources')
				}
			},
			{
				path: '/cms/lifeEvents',
				component: AdminSection,
				name: 'cmsLifeEvents',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsLifeEvents'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.lifeEvents')
				}
			},
			{
				path: '/cms/miscUploads',
				component: AdminSection,
				name: 'cmsMiscUploads',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsMiscUploads'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.miscUploads')
				}
			},
			{
				path: '/cms/facility',
				component: AdminSection,
				name: 'cmsFacility',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsFacility'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.facility')
				}
			},
			{
				path: '/cms/users',
				component: AdminSection,
				name: 'cmsUsers',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'cms',
					selectedCmsOption: 'cmsUsers'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.userManagement')
				}
			},
			{
				path: '/admin/messages',
				component: AdminSection,
				name: 'messages',
				beforeEnter: isAllowed,
				props: { selectedOption: 'messages' },
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.messages')
				}
			},
			{
				path: '/admin/students',
				component: AdminSection,
				name: 'students',
				beforeEnter: isAllowed,
				props: { selectedOption: 'students' },
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.students')
				}
			},
			{
				path: '/admin/resources',
				component: AdminSection,
				name: 'resources',
				beforeEnter: isAllowed,
				props: { selectedOption: 'resources' },
				meta: {
					title: i18nInstance.t('adminMetaTitles.resources')
				}
			},
			{
				path: '/admin/simulation',
				component: AdminSection,
				name: 'simulationManagement',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'simulationManagement'
				},
				meta: {
					title: i18nInstance.t('adminMetaTitles.simManagement')
				}
			},
			{
				path: '/admin/reporting',
				component: AdminSection,
				name: 'reporting',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'reporting'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.reporting')
				}
			},
			{
				path: '/admin/settings',
				component: AdminSection,
				name: 'settings',
				beforeEnter: isAllowed,
				props: {
					selectedOption: 'settings'
				},
				meta: {
					middleware: Localize,
					title: i18nInstance.t('adminMetaTitles.settings')
				}
			},
			{ path: '/admin', name: 'admin', redirect: '/admin/messages' },
			{
				path: '/congratulations',
				component: Congratulations,
				name: 'congratulations',
				beforeEnter: isAllowed,
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('congratulationsPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.congrats')
				}
			},
			{
				path: '/admin/studentview',
				name: 'studentview',
				props: true,
				beforeEnter: (to, from, next) => {
					store.dispatch('getUserData').then(({ data }) => {
						if (!data || !data.isUserLoggedIn) {
							redirectLogin(to, from, next);

							// prevent next lines to be executed
							return;
						}

						if (
							data.disAllowedUrlPaths.includes(to.name) ||
							to.name == 'root'
						) {
							// if url is not allowed, redirect to allowed page
							next({ name: data.urlPathToNavigateAfterLogin });

							// prevent next lines to be executed
							return;
						}

						const { sid, demoSuid } = to.query;

						sessionStorage.setItem(
							'viewAsStudent',
							JSON.stringify({
								simulationId: sid,
								isViewAsStudent: true,
								demoStudentUniqueEmail: demoSuid
							})
						);
						// Force redirect to root when ViewAsStudent is set
						// this will enable "view as a student" option, which is
						// loaded on root by default
						next({ name: 'root' });
					});
				}
			},

			{ path: '/internalerror', component: InternalError },
			{
				path: '/userauthenticationerror',
				name: 'userauthenticationerror',
				component: SimulationError,
				props: true
			},
			{
				path: '/category',
				name: 'category',
				component: Category,
				props: true,
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('categoryPageEntered')
					}
				}
			},
			{
				path: '/loan',
				name: 'loan',
				component: LoanApplication,
				props: true,
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('categoryPageEntered')
					}
				}
			},
			{
				path: '/profile',
				name: 'profile',
				component: Profile,
				beforeEnter: isAllowed,
				meta: {
					middleware: Localize,
					announcer: {
						message: i18nInstance.tc('profilePageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.profile')
				}
			},
			{
				path: '/calendar',
				name: 'calendar',
				component: Calendar,
				beforeEnter: isAllowed,
				meta: {
					announcer: {
						message: i18nInstance.tc('calendarPageEntered')
					},
					title: i18nInstance.t('gamePlayMetaTitles.calendar')
				}
			},
			{
				path: '/report/studentatglance',
				name: 'studentAtGlance',
				component: StudentAtGlanceReport,
				props: true
			},
			{
				path: '/report/studentsummary',
				component: StudentSummaryReport,
				name: 'studentSummary',
				beforeEnter: isAllowed,
				meta: {
					announcer: {
						message: i18nInstance.tc('studentSummaryEntered')
					}
				}
			},
			{
				path: '/report/simulationsnapshot',
				name: 'simulationSnapshot',
				component: SimulationSnapshotReport,
				props: true
			},
			{ path: '/studentsummary', redirect: '/report/studentsummary' },
			{ path: '/notfound', component: NotFoundComponent },
			{ path: '/', beforeEnter: isAllowed, name: 'root' },
			{ path: '*', redirect: '/notfound' }
		];
	}
	return routes;
};
